/**
 * SB6-II-01 — TanStack Query keys for the inspection-instructions feature.
 */
import type { ListInspectionInstructionsParams } from "./types.js";

export const iiKeys = {
  all: ["inspection-instructions"] as const,
  lists: () => [...iiKeys.all, "list"] as const,
  list: (params: ListInspectionInstructionsParams) =>
    [...iiKeys.lists(), params] as const,
  facets: () => [...iiKeys.all, "facets"] as const,
  projectFacet: () => [...iiKeys.facets(), "projects"] as const,
  siteFacet: (q: string) => [...iiKeys.facets(), "sites", q] as const,
  assetFacet: (q: string) => [...iiKeys.facets(), "assets", q] as const,
  assignableUsers: (id: string | null) =>
    [...iiKeys.all, "assignable-users", id] as const,
  options: () => [...iiKeys.all, "options"] as const,
  projectOptions: () => [...iiKeys.options(), "projects"] as const,
  contractOptions: (projectId: string | null) =>
    [...iiKeys.options(), "contracts", projectId] as const,
  contractPositionOptions: (contractId: string | null) =>
    [...iiKeys.options(), "contract-positions", contractId] as const,
  companyOptions: (q: string) => [...iiKeys.options(), "companies", q] as const,
  detail: (id: string | null) => [...iiKeys.all, "detail", id] as const,
};
